import React from 'react';
import { Link } from 'react-router-dom';
import SafeChurchLogo from './SafeChurchLogo';

/** Small "Safe Church Compliant" pill linking to the Safe Church page. */
export const SafeChurchBadge = ({ variant = 'light', testId = 'safe-church-badge', className = '' }) => (
  <Link
    to="/ministries/restore/safe-church"
    data-testid={testId}
    className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${
      variant === 'onDark' ? 'border-green-600 text-green-100 hover:text-white hover:border-green-400' : 'border-teal-200 bg-teal-50 text-teal-800 hover:border-teal-400'
    } ${className}`}
  >
    <SafeChurchLogo size={18} variant={variant === 'onDark' ? 'light' : 'dark'} className="flex-shrink-0" />
    Safe Church Compliant
  </Link>
);
